import scalingThroughChaos from './scaling_through_chaos.json'

export default scalingThroughChaos
